import { Testimonial } from "../../types/testimonial";
import verifiedImg from "../../assets/img/verified.png";
import verifiedImgWebp from "../../assets/img/verified.webp";
import ratingImg from "../../assets/img/rating.png";
import ratingImgWebp from "../../assets/img/rating.webp";

type Props = {
    testimonials: Testimonial[],
};

const TestimonialsMessage = ({
    testimonials,
}: Props) => (
    <div className="row justify-content-center align-items-center">
        <div className="col-xxl-7 col-xl-8 col-lg-10 col-md-12 col-sm-10">
            {testimonials.map((testimonial, index) => (
                <div className="row justify-content-center align-items-center gg-border-radius gg-bg-solid-white py-2 mb-3" key={index}>
                    <div className="col-md-3 px-0 pt-2">
                        <div className="row justify-content-center align-items-center">
                            <div className="col-md-8 col-sm-3 col-4 text-start">
                                <picture>
                                    <source srcSet={testimonial.imgWebp} type="image/webp" />
                                    <img className="img-fluid rounded-circle gg-img-customer-row" alt="customer" src={testimonial.img} loading="lazy" />
                                </picture>
                            </div>
                        </div>
                        <div className="row justify-content-center align-items-center mb-1">
                            <div className="col-12 text-center">
                                <picture>
                                    <source srcSet={verifiedImgWebp} type="image/webp" />
                                    <img className="img-fluid gg-img-verified" alt="verified" src={verifiedImg} loading="lazy" />
                                </picture>
                                <span className="gg-text-verified text-nowrap"> Verified Customer</span>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-9 col-11">
                        <div className="row">
                            <div className="col-md-4 text-md-start text-center">
                                <picture>
                                    <source srcSet={ratingImgWebp} type="image/webp" />
                                    <img className="img-fluid gg-testimonial-img-rating" alt="rating" src={ratingImg} loading="lazy" />
                                </picture>
                            </div>
                        </div>
                        <div className="row text-md-start text-center pt-2">
                            <h6 className="fw-bold">{testimonial.title}</h6>
                            <p className="gg-text-testimonial">{testimonial.text}</p>
                            <h6>{testimonial.name}</h6>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    </div>
)

export default TestimonialsMessage;